import {FormControl} from "@angular/forms";
import {Fitrite365QuoteMeasurement} from "./Fitrite365QuoteMeasurement";

export class QuoteCreationRequest {
  templateId: string;
  customerId: number;
  customerName: string;
  customerEmail: string;
  customerPhone: string;
  deckColour: string;
  balustradeColour: string;
  plot: string;
  comments?: string;
}
